// The agency's rates (value of a deal / meeting / client / owner item), measured over the last
// values_window_days across ALL agents and offices, gated (lib/agentValue.js inReference). ONE hook
// for the Desk rail and the Stats tab (audit 2026-11-03): the Stats tab used to take these rates only
// when this browser happened to have the rail's cache and otherwise measured its own range, so two
// managers could see two scores for the same agent.
import { useEffect, useState } from 'react'
import { getActivityRanking, getAgentDeals, readDeskCache, writeDeskCache } from '../../db/core.js'
import { agentInputs, deriveValues, inReference, VALUE_DEFAULTS } from '../../lib/agentValue.js'

const DAY = 86400000
const VALUES_TTL_MS = 24 * 60 * 60 * 1000   // the agency's rates move slowly; measure once a day

export function useAgencyValues(enabled, roster, cfg, fx) {
  const [vals, setVals] = useState(() => readDeskCache('vals1'))
  useEffect(() => {
    // An empty roster measures nothing and would cache the fallback rates for a day.
    if (!enabled || !roster.length) return
    let dead = false
    const cached = readDeskCache('vals1')
    if (cached && Date.now() - (cached.__at || 0) < VALUES_TTL_MS) { setVals(cached); return }
    const C = { ...VALUE_DEFAULTS, ...(cfg || {}) }
    const since = new Date(Date.now() - C.values_window_days * DAY).toISOString()
    Promise.all([getActivityRanking(since), getAgentDeals(since)]).then(([a, d]) => {
      if (dead) return
      const inp = agentInputs({ roster, activity: a.ranking || [], deals: d.deals || [], att: [], schedHist: [], since, until: null, fx })
      const v = deriveValues(inp.rows.filter(r => inReference(r, cfg, { needSchedule: false })), cfg)
      const next = { ...v, __at: Date.now() }
      setVals(next); writeDeskCache('vals1', next)
    }).catch(e => console.error('[agent-values]', e.message))
    return () => { dead = true }
  }, [enabled, roster.length])
  return vals
}
